import {
  transformCreditsAutoRechargeConfig,
  transformCreditsWithdraw,
  transformCreditsWithdrawable,
} from '@/common/integrations/menhir/employee/credits/credits.dto';
import {
  TCreditsAutoRechargeConfig,
  TMenhirCreditsAutoRechargeConfig,
  TMenhirCreditsWithdrawble,
  TMenhirPatchCreditsAutoRechargeConfigPayload,
  TMenhirPostCreditsWithdrawPayload,
  TMenhirPostCreditsWithdrawResponse,
  TPatchCreditsAutoRechargeConfigPayload,
} from '@/common/integrations/menhir/employee/credits/credits.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { AxiosRequestConfig } from 'axios';

export function getCreditsAutoRechargeConfig() {
  return menhirClient
    .get<
      null,
      { auto_recharge: TMenhirCreditsAutoRechargeConfig }
    >(MENHIR_ENDPOINTS.EMPLOYEE.CREDITS.CONFIG.AUTO_RECHARGE)
    .then((envelope) => {
      return transformCreditsAutoRechargeConfig(envelope.auto_recharge);
    });
}

export function setupCreditsAutoRechargeConfig(
  payload: TCreditsAutoRechargeConfig
) {
  return menhirClient
    .post<null, { auto_recharge: TMenhirCreditsAutoRechargeConfig }>(
      MENHIR_ENDPOINTS.EMPLOYEE.CREDITS.CONFIG.AUTO_RECHARGE,
      {
        target_amount: payload.targetAmount,
        threshold_amount: payload.thresholdAmount,
        payment_method_id: payload.paymentMethodId,
      } satisfies TMenhirCreditsAutoRechargeConfig
    )
    .then((envelope) =>
      transformCreditsAutoRechargeConfig(envelope.auto_recharge)
    );
}

export function editCreditsAutoRechargeConfig(
  payload: TPatchCreditsAutoRechargeConfigPayload
) {
  return menhirClient
    .patch<null, { auto_recharge: TMenhirCreditsAutoRechargeConfig }>(
      MENHIR_ENDPOINTS.EMPLOYEE.CREDITS.CONFIG.AUTO_RECHARGE,
      {
        target_amount: payload.targetAmount,
        threshold_amount: payload.thresholdAmount,
        payment_method_id: payload.paymentMethodId,
      } satisfies TMenhirPatchCreditsAutoRechargeConfigPayload
    )
    .then((envelope) =>
      transformCreditsAutoRechargeConfig(envelope.auto_recharge)
    );
}

export function deleteCreditsAutoRechargeConfig() {
  return menhirClient.delete(
    MENHIR_ENDPOINTS.EMPLOYEE.CREDITS.CONFIG.AUTO_RECHARGE
  );
}

export function getWithdrawbleCredits() {
  return menhirClient
    .get<
      null,
      { credits: TMenhirCreditsWithdrawble }
    >(MENHIR_ENDPOINTS.EMPLOYEE.CREDITS.ROOT)
    .then((envelope) => {
      return transformCreditsWithdrawable(envelope.credits);
    });
}

export function postWithdrawCredits(
  payload: TMenhirPostCreditsWithdrawPayload,
  config?: AxiosRequestConfig
) {
  return menhirClient
    .post<null, TMenhirPostCreditsWithdrawResponse>(
      MENHIR_ENDPOINTS.EMPLOYEE.CREDITS.WITHDRAWAL,
      {
        amount: payload.amount,
      },
      config
    )
    .then((envelope) => {
      return transformCreditsWithdraw({
        operation_id: envelope.operation_id,
      });
    });
}

export const CreditsService = {
  getCreditsAutoRechargeConfig,
  setupCreditsAutoRechargeConfig,
  editCreditsAutoRechargeConfig,
  deleteCreditsAutoRechargeConfig,
  getWithdrawbleCredits,
  postWithdrawCredits,
};
